import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError, getUTCTimeStamp } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { method } from './executeTransaction'
import { sendEventApi } from './sendEvent'

const getErrorMessage = (data: any, transferType: any) => {
  if (transferType === 'BALENCE ENQUIRY' || transferType === 'MINI STATEMENT' || data?.data?.error?.code === '305') {
    return 'Please enter valid Transaction ID.'
  } else {
    return data?.data?.error?.message ?? 'An unexpected error has occoured'
  }

  // (data?.data?.error?.code==='305'|| !data?.data?.error?.message)?'Please enter valid Transaction ID.' :data?.data?.error?.message
}

const getErrorCode = (data: any, transferType: any) =>
  transferType === 'BALENCE ENQUIRY' || transferType === 'MINI STATEMENT' ? '305' : data?.data?.error?.code

const responseParser = (data: any, transactionId: any) => {
  const transferType = getTransferType(data?.data?.transaction?.method?.type)
  if (transferType === 'BALENCE ENQUIRY' || transferType === 'MINI STATEMENT' || data?.data?.error) {
    throw {
      code: getErrorCode(data, transferType),
      message: getErrorMessage(data, transferType),
      transactionId,
    }
  } else {
    const type = parseInt(data?.transaction?.method?.type)
    return {
      transactionId: data?.data?.transaction?.id,
      amount: data?.data?.amount?.netAmount + '',
      tnxTime: data?.data?.transaction?.created,
      rrnNo: data?.data?.transaction?.rrn,
      message: data?.data?.transaction?.status ?? getNetworkResponseError(data?.data)?.message,
      status: data?.data?.transaction?.status === 'SUCCESS' ? 'SUCCESS' : 'FAILURE',
      transferType: getTransferType(data?.data?.transaction?.method?.type),
      customerName:
        type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER ? data?.payer?.name : data?.payee?.name,
      mobileNo:
        type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER
          ? data?.payer?.mobileNumber
          : data?.payee?.mobileNumber,
      bankName:
        type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER
          ? data?.payer?.bankName
          : data?.payee?.bankName,
    }
  }
}

export const fetchParticularTransaction = (tokens: any, req: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.fetchTransactionDetail,
    //apiPath: 'http://10.162.6.163:9012/jpb/v1/aeps/payouts/status',
    method: 'POST',
    config: apiConfig(tokens),
    body: req,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, req?.transactionId)
    })
    .then((data) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return data
    })
    .catch((error) => {
      sendEventApi(tokens, request, {
        errorDescription: error,
        status: 'FAILED',
      })
      throw error
    })
}

export const getParticularTransactionRequest = (transactionId: string) => {
  return {
    rrn: transactionId,
    application: RootStore?.agent?.session?.CHANNEL_ID,
    initiatingEntityTimestamp: getUTCTimeStamp(),
    entityId: RootStore?.agent?.session?.CHANNEL_ID,
  }
}

const getTransferType = (type: any) => {
  if (type == method.CASH_WITHDRAWAL) {
    return 'CASH WITHDRAWAL'
  } else if (type == method.CASH_DEPOSIT) {
    return 'CASH DEPOSIT'
  } else if (type == method.MINI_STATEMENT_TYPE) {
    return 'MINI STATEMENT'
  } else if (type == method.BALENCE_ENQUIRY_TYPE) {
    return 'BALENCE ENQUIRY'
  } else if (type == method.FUND_TRANSFER) {
    return 'FUND TRANSFER'
  }
  return ''
}

export const transactionStatusParser = (data: any) => {
  const type = parseInt(data?.transaction?.method?.type)
  return {
    transactionId: data?.transaction?.id,
    amount: data?.amount?.netAmount + '',
    tnxTime: data?.transaction?.created,
    rrnNo: data?.transaction?.rrn,
    message: data?.transaction?.status ?? getNetworkResponseError(data?.data)?.message,
    status: data?.transaction?.status,
    transferType: getTransferType(data?.transaction?.method?.type),
    customerName:
      type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER ? data?.payer?.name : data?.payee?.name,
    mobileNo:
      type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER
        ? data?.payer?.mobileNumber
        : data?.payee?.mobileNumber,
    bankName:
      type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER ? data?.payer?.bankName : data?.payee?.bankName,
  }
}
